"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { DefaultImage } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"

import { RenderConfig } from "./RenderConfig"
import type { ServiceShowcaseProps } from "./types/config"

export const ServiceShowcase: ComponentConfig<ServiceShowcaseProps> = {
  label: "Tamda One | Service Showcase",
  fields: {
    defaultBackgroundImage: {
      label: "Default Background Image",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    defaultTitle: {
      label: "Default Title",
      type: "text",
    },
    defaultDescription: {
      label: "Default Description",
      type: "textarea",
    },

    logo: {
      label: "Logo",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },

    sectionTitle: {
      label: "Section Title",
      type: "text",
    },

    buttonText: {
      label: "Button Text",
      type: "text",
    },
    buttonLink: {
      label: "Button Link",
      type: "text",
    },

    services: {
      label: "Services",
      type: "array",
      arrayFields: {
        backgroundImage: {
          label: "Background Image",
          type: "custom",
          render: props => <MediaSelect {...props} mediaType="image" />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
      getItemSummary: item => item.title || "Service",
      defaultItemProps: {
        backgroundImage: DefaultImage,
        title: "Service",
        description: "Service description",
        link: "#",
      },
    },

    slidesPerView: {
      label: "Slides Per View",
      type: "number",
      min: 1,
      max: 6,
    },
    spaceBetween: {
      label: "Space Between (px)",
      type: "number",
      min: 0,
      max: 100,
    },

    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    defaultBackgroundImage: DefaultImage,
    defaultTitle: "TAMDA GROUP",
    defaultDescription: "Tập đoàn TAMDA",
    logo: DefaultImage,
    sectionTitle: "CHÚNG TÔI CUNG CẤP CÁC DỊCH VỤ NỔI BẬT",
    buttonText: "Xem thêm",
    buttonLink: "#",
    services: [
      {
        backgroundImage: DefaultImage,
        title: "Kinh doanh thực phẩm",
        description:
          "Tamda Group xây dựng chuỗi hệ thống siêu thị Tamda Foods tại các tỉnh thành phố lớn tại CH Séc, phục vụ chủ yếu bán buôn cho các công ty kinh doanh bán lẻ ngành hàng thực phẩm và đồng thời cũng bán lẻ theo nhu cầu. Các mặt hàng chủ yếu là ngành hàng thực phẩm, bên cạnh đó cũng có đầy đủ các mặt hàng hóa mỹ phẩm, hàng gia dụng và các mặt hàng tiện dụng.",
        link: "#",
      },
      {
        backgroundImage: DefaultImage,
        title: "E-Shop",
        description:
          "Kênh bán hàng online được ra đi kèm dịch vụ giao hàng nhanh tại khắp các tỉnh thành CH Séc - Tamda Express. Tại đây, cung cấp đầy đủ các mặt hàng giống như tại các hệ thống siêu thị Tamda Foods. Nhờ đó, các khách hàng tại các tỉnh thành xa xôi đã rất thuận tiện khi đặt hàng hóa, không phải di chuyển xa hay lo lắng hết hàng hay gặp các vấn đề về vận chuyển.",
        link: "#",
      },
      {
        backgroundImage: DefaultImage,
        title: "Nhập khẩu",
        description:
          "Một trong những thế mạnh của Tamda Group từ những ngày đầu đó là nhập khẩu các mặt hàng thực phẩm từ Việt Nam và châu Á chất lượng cao được tiếp cận thị trường Séc. Các đối tác của Tamda group tại Việt Nam và châu Á đều là những doanh nghiệp uy tín và đã có kinh nghiệm cung ứng hàng hóa cho hầu hết các thị trường khó tính trên thế giới.",
        link: "#",
      },
      {
        backgroundImage: DefaultImage,
        title: "Truyền thông",
        description:
          "TamdaMedia - Kênh thông tin gần gũi với cộng đồng người Việt, đã, đang và sẽ luôn cung cấp các tin tức thời sự nóng hổi và cập nhật các thông tin hữu ích tại Séc, thế giới, Việt Nam đến với khán giả. Qua đó quảng bá, giới thiệu hình ảnh đất nước, con người Việt Nam đến bạn bè sở tại và quốc tế.",
        link: "#",
      },
      {
        backgroundImage: DefaultImage,
        title: "Kinh doanh Bất động sản",
        description:
          "TTTM Tamda tại thành phố Ústí nad Labem được Tamda Group đầu tư xây dựng trên quy mô rộng lớn trên diện tích hơn 80 ngàn m². Tại đây có 1 chi nhánh siêu thị Tamda Foods, nhiều cơ sở kinh doanh nhỏ lẻ, nhà hàng ẩm thực đã và đang hoạt động. Các doanh nghiệp lớn cũng đang kinh doanh tại TTTM Tamda đó là AAA Auto và KFC",
        link: "#",
      },
    ],
    slidesPerView: 4,
    spaceBetween: 32,
    className: "",
  },
  ...RenderConfig,
}

export type { ServiceItem, ServiceShowcaseProps } from "./types/config"
